<div class="personal-infomation p-4 mt-4">
    <div class=" d-flex justify-content-between ">
        <h2 class="profile-heading">Members</h2>
        <div class="d-flex">
            <img class="edit-profile mx-1" alt="" src="../../assets/images/add.svg" (click)="addMember()">
            <img class="edit-profile " alt="" src="../../assets/images/editprofile.svg" (click)="editMember()">
        </div>
    </div>
    <div class="mt-2" *ngIf="!showEditForm">
        <app-mwe-table [columns]="membersColumns" [showHeader]="false" [showPagination]="false"
            [data]="data"></app-mwe-table>
    </div>
    <form [formGroup]="membersForm" *ngIf="showEditForm">
        <div formArrayName="members">
            <div *ngFor="let memberForm of members?.controls; let i=index;">
                <div [formGroupName]="i">
                    <div class="card p-2 mt-4">
                        <div class="main">
                            <div class="upload-image">

                                <div class="mx-1">
                                    <img src="{{memberForm.get('image')?.value?memberForm.get('image')?.value:'../../../../../assets/images/avatar.svg'}}"
                                        class="image">

                                </div>
                                <div class="profile-action mx-1">
                                    <div class="row upload-row">
                                        <div class="col-lg-12 ">
                                            <input class="d-none" type="file" id="{{'uploadImage'+i}}"
                                                accept=".png,.jpg,.jpeg" (change)="uploadImage($event,i)" (keydown)="handleKeyDown($event)">
                                            <label class=" upload "
                                                for="{{'uploadImage'+i}}"><mat-icon>cloud_upload</mat-icon>

                                            </label>
                                        </div>
                                        <div class="col-lg-12 mt-1"><mat-icon class="delete-icon"
                                                (click)="clearImage(i)">delete</mat-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 d-flex flex-wrap ">
                                <div class="mx-1 my-4 col-lg-3 col-md-6 member-profile">
                                    <div>
                                        <p
                                            class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0">
                                            Name<span style="color: red;">*</span></p>
                                    </div>
                                    <div>
                                        <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                            <input matInput formControlName="name" placeholder="Enter Name" (keydown)="handleKeyDown($event)">
                                            <mat-error class="error-message error-msg"
                                                *ngIf="memberForm.get('name')?.hasError('required')">
                                                <img class="error-icon" loading="eager" alt=""
                                                    src="./../../assets/images/alert.svg" />
                                                Name is Required</mat-error>
                                            <mat-error class="error-message error-msg member-name-error"
                                                *ngIf="memberForm.get('name')?.hasError('pattern') || memberForm.get('name')?.hasError('maxlength')">
                                                <img class="error-icon" loading="lazy" alt=""
                                                    src="./../../assets/images/alert.svg" />
                                                {{memberForm.get('name')?.hasError('pattern')?' Only Alphabets are Allowed':' Limit Exceeded: Max 50 characters'}}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="mx-1 my-4 col-lg-3 col-md-6 member-profile">
                                    <div>
                                        <p
                                            class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0">
                                            Email<span style="color: red;">*</span>
                                        </p>
                                    </div>
                                    <div>
                                        <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                            <input matInput formControlName="email" placeholder="Enter your email"
                                                type="email" (keydown)="handleKeyDown($event)">
                                            <mat-error class="error-message error-msg"
                                                *ngIf="memberForm.get('email')?.hasError('required')">
                                                <img class="error-icon" loading="eager" alt=""
                                                    src="./../../assets/images/alert.svg" />
                                                Email is Required
                                            </mat-error>
                                            <mat-error class="error-message error-msg member-email-errorinvalid"
                                                *ngIf="memberForm.get('email')?.hasError('pattern')">
                                                <img class="error-icon" loading="eager" alt=""
                                                    src="./../../assets/images/alert.svg" />
                                                Invalid Email Format
                                            </mat-error>
                                            <mat-error class="error-message error-msg member-email-error"
                                                *ngIf="memberForm.get('email')?.hasError('maxlength')">
                                                <img class="error-icon" loading="eager" alt=""
                                                    src="./../../assets/images/alert.svg" />
                                                Limit Exceeded Max : 50 characters
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="mx-1 my-4 col-lg-3 col-md-6">
                                    <div>
                                        <p
                                            class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0">
                                            Phone Number<span style="color: red;">*</span></p>
                                    </div>
                                    <div>
                                        <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                            <input matInput formControlName="phone"
                                                placeholder="Enter Valid Phone Number" onlyNumbers (keydown)="handleKeyDown($event)">
                                            <mat-error *ngIf="memberForm.get('phone')?.hasError('required')">
                                                <img class="error-icon" src="./../../assets/images/alert.svg" />
                                                Phone Number is Required
                                            </mat-error>
                                          <mat-error *ngIf="memberForm.get('phone')?.hasError('maxlength')">
                                                <img class="error-icon" src="./../../assets/images/alert.svg" />
                                                Limit Exceeded: Max 15 characters
                                            </mat-error>
                                            <mat-error *ngIf="memberForm.get('phone')?.hasError('minlength')">
                                                <img class="error-icon" src="./../../assets/images/alert.svg" />
                                                Min length should be 10 digits
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                </div>

                                <div class="mx-1 col-lg-3 col-md-6">
                                    <div>
                                      <p class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0">
                                        Account Type
                                      </p>
                                    </div>
                                    <div>
                                      <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                        <input type="text" matInput
                                               [formControl]="accountTypeSearchControls[i]"
                                               [matAutocomplete]="autoAccountType"
                                               placeholder="Select Account Type">
                                        <mat-autocomplete #autoAccountType="matAutocomplete"
                                                          (optionSelected)="onAccountTypeSelected($event, i)"
                                                          [displayWith]="displayAccountType">
                                          <mat-option *ngFor="let accountType of filteredAccountTypes[i] | async" [value]="accountType">
                                            {{ accountType.name }}
                                          </mat-option>
                                        </mat-autocomplete>
                                      </mat-form-field>
                                    </div>
                                  </div>

                                <div class="mx-1 col-lg-3 col-md-6">
                                    <div>
                                        <p class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0">
                                            Position
                                        </p>
                                    </div>
                                    <div>
                                        <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="Select Position"
                                                aria-label="Position"
                                                [formControl]="getPositionControl(i)"
                                                [matAutocomplete]="autoPosition"
                                                (keydown)="handleKeyDown($event)"
                                            >
                                            <mat-autocomplete
                                                #autoPosition="matAutocomplete"
                                                (optionSelected)="onPositionSelected($event, i)"
                                                [displayWith]="displayPosition"
                                            >
                                                <mat-option
                                                    *ngFor="let position of (filteredPositions[i] | async)"
                                                    [value]="position"
                                                >
                                                    {{ position?.name }}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>
                                </div>
                               <div class="mt-4 mx-1 col-lg-3 col-md-6">
                                    <button class="mwe-button mwe-button--secondary delete-button ps-3 pe-3 "
                                        (click)="deleteMember(i)">Delete</button>
                                </div>
                            </div>
                        </div>
                   </div>
                </div>
            </div>
        </div>

    </form>
    <div class="profile-action " *ngIf="showEditForm">


        <button class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3"
            (click)="update()">Update</button>

        <button class="mwe-button mwe-button--secondary ps-3 pe-3 " (click)="cancel()">Cancel</button>

    </div>
</div>